import script from "./MultiPatientBar.vue?vue&type=script&setup=true&lang=js"
export * from "./MultiPatientBar.vue?vue&type=script&setup=true&lang=js"

import "./MultiPatientBar.vue?vue&type=style&index=0&id=034edc18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-034edc18"]])

export default __exports__